/* Small messages. Replaces iziToast — no reason to drag in jQuery for four
   lines of CSS and a timeout. */
import { createContext, useContext, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Ctx = createContext(() => {});
export const useToast = () => useContext(Ctx);

export function ToastHost({ children }) {
  const [list, setList] = useState([]);

  const say = useCallback((text, type = 'ok') => {
    const id = Date.now() + Math.random();
    setList(l => [...l, { id, text, type }]);
    setTimeout(() => setList(l => l.filter(x => x.id !== id)), 3200);
  }, []);

  return (
    <Ctx.Provider value={say}>
      {children}
      <div className="toast-surface" aria-live="polite">
        <AnimatePresence>
          {list.map(t => (
            <motion.div
              key={t.id}
              className={'toast' + (t.type === 'error' ? ' error' : '')}
              initial={{ opacity: 0, y: 10, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.97 }}
            >
              {t.text}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </Ctx.Provider>
  );
}
